import React from "react";
import Trigger from "@rc-component/trigger";

import css from "./Dropdown.module.css";

import cn from "classnames";

import { Typography } from "../Typography/Typography";
import { Icon } from "../Icon/Icon";

type Option<T> = {
    label: string;
    value: T;
};

type DropdownProps<T> = {
    options: Option<T>[];
    value?: T;
    onChange: (value: T) => void;
    message?: string;
    isDisabled?: boolean;
};

export const Dropdown = <T,>({
    options,
    value,
    onChange,
    message,
    isDisabled,
}: DropdownProps<T>) => {
    const selectedOption = options.find((o) => o.value === value);
    const hasOptions = options.length > 0;

    return (
        <div className={cn(css.container, isDisabled && css.disabled)}>
            <Trigger
                action={["click"]}
                popup={
                    <div className={cn(css.optionsContainer, !hasOptions && css.empty)}>
                        {hasOptions ? (
                            options.map((option, index) => (
                                <div
                                    className={css.option}
                                    key={index}
                                    onClick={() => onChange(option.value)}
                                >
                                    <span>{option.label}</span>
                                    {option.value === value && <Icon icon="check-solid" />}
                                </div>
                            ))
                        ) : (
                            <Typography variant="body" color="gray3">
                                Nothing found
                            </Typography>
                        )}
                    </div>
                }
                popupAlign={{
                    points: ["tr", "br"],
                    offset: [0, 10],
                }}
                autoDestroy
                stretch="width"
            >
                <div className={css.main}>
                    <Typography variant="body-medium">{selectedOption?.label}</Typography>
                    <Icon icon="chevron-down" />
                </div>
            </Trigger>
            <Typography variant="label">{message}</Typography>
        </div>
    );
};
